export var CONTEXTMENU_CLASS_PREFIX = 'ContextMenu';